<template>
  <div class="search-home" :class="[isClient ? 'client' : 'web']">
    <div class="home-search">

      <search-left></search-left>
      
      <!-- <wechat-app v-if="isClient"></wechat-app> -->
      
      <search-input
        :inputHeight="40"
        :searchInputWidth="430"
        :fontSize="14"
        :openNew="true"
      />

      <geometric-search></geometric-search>

    </div>
    <mostly-search @fresh-search="freshSearch" />
    <div class="content-s" @mouseover="_clearRecommedInterval" @mouseout="_setRecommedInterval">

      <div class="title">
        <span class="title-con">Hello，我们为您推荐了一些可能感兴趣的产品关键词</span>
        <!-- 临时测试使用 -->
        <!-- <div class="smart3d-btn" @click="goSmart3D" v-if="['191887','204'].includes(`${user.UserID}`)"><span>大工程师</span></div> -->
        <div class="znzs" @click="feedbackShow">
          <!-- <i class="el-icon el-icon-service" style="font-size: 16px;margin-right: 6px;"></i>
          <span>智能助手</span> -->
          <img src="https://prodimg.global-dsc.cn/dgzz_img/xuanchuan/48efa0cca53ec5f213c658e5958a5e77.png" style="height: 50px;" />
        </div>
      </div>

      <rec-keywords
        ref="recKeywords"
        :rightLoading="rightLoading"
        :activeIndex="activeIndex"
        @indexChange="indexChange"
        @recommendProducts="recommendProducts"
      ></rec-keywords>

      <rec-products
        ref="recProductsRef"
        :rightLoading="rightLoading"
        @loadingChange="loadingChange"
      ></rec-products>
    </div>

    <rec-swiper></rec-swiper>

    <search-feedback
      ref="feedbackRef"
    ></search-feedback>

    <join-in ref="joinInRef"></join-in>
    <join-in-dialog></join-in-dialog>

    <adverts-activate></adverts-activate>
  </div>
</template>

<script>
import {CheckLibs} from '@digital-supply-chain/module'
import {OpenService,AuthService} from '@/service'
import {DomainService} from '@/libs'

import SearchInput from "../components/search-input.vue";
import SearchFeedback from "../components/search-feedback.vue";
import MostlySearch from "./components/mostly-search.vue";
import RecKeywords from "./rec-keywords.vue";
import RecProducts from "./rec-products.vue";
import RecSwiper from "./rec-swiper.vue";

import SearchLeft from './search-left.vue'

import WechatApp from "./components/wechat-app.vue";
import GeometricSearch from "./components/geometric-search.vue";

import JoinIn from '@/views/activity/joinin/index.vue'
import JoinInDialog from '@/views/activity/joinin/joinin-dialog.vue'

// 启动页广告
import AdvertsActivate from './components/adverts-activate.vue'

export default {
  components: {
    SearchLeft,
    SearchInput,
    SearchFeedback,
    MostlySearch,
    RecKeywords,
    RecProducts,
    RecSwiper,
    WechatApp,
    GeometricSearch,
    JoinIn,
    JoinInDialog,
    AdvertsActivate
  },
  data() {
    return {
      activeIndex: 0,
      rightLoading: false,
      user: AuthService.user(),
      codeImgUrl: `${DomainService.PublicPath}resource/images/dggj.png`,
      isClient: CheckLibs.isClient(),
    }
  },
  mounted() {
    console.log(this.user.UserID);
  },
  methods: {
    goSmart3D() {
      window.open(`${DomainService.BlogWeb}/#/home/recommend`);
    },
    indexChange(value) {
      this.activeIndex = value;
    },
    loadingChange(bool = false) {
      this.rightLoading = bool;
    },
    freshSearch(keyword) {
      OpenService.openSearchLib(keyword, true);
    },
    feedbackShow() {
      this.$refs.feedbackRef.show();
    },
    recommendProducts() {
      const keywords = this.$refs.recKeywords.recommendKeywords[this.activeIndex];
      this.$refs.recProductsRef.recommendProducts(keywords);
    },
    // 用户无操作时的关键词自动切换
    _setRecommedInterval() {
      this.$refs.recKeywords._setRecommedInterval();
    },
    // 相对应的定时任务清除
    _clearRecommedInterval() {
      this.$refs.recKeywords._clearRecommedInterval();
    },

    // 合伙人招募弹窗
    joinInOpen() {
      this.$refs.joinInRef.open();
    }
  },
}
</script>

<style lang="less" scoped>
  .search-home{
    padding-top: 24px;
    &.web{
      padding-top: 50px;
    }
  }
  .wxapp-code{
    position: absolute;
    left: -50px;
    top: -30px;
    width: 100px;
    height: 100px;
    z-index: 999;
    img{
      width: 100%;
    }
  }
  .home-search{
    width: 900px;
    margin: 0 auto;
    position: relative;
  }
  .content-s{
    padding: 0 25px;
  }
  .title{
    width: 100%;
    display: flex;
    color: #ffffff;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    background: @main-color;
    padding: 0 16px;
    .znzs{
      cursor: pointer;
      font-size: 15px;
      position: absolute;
      right: 50px;
      z-index: 10;
    }
    .title-con{
      margin-right: 24px;
      flex: 1;
    }
    .smart3d-btn{
      margin-right: 18px;
      cursor: pointer;
    }
  }
</style>
